export default class CollapseManager {

    constructor() {
        this.eventDelegation();
    }

    eventDelegation() {
        document.body.querySelectorAll('[data-action="toggle-collapse"][data-target]')
            .forEach(this.registerCollapseButton.bind(this))
    }

    registerCollapseButton(element) {
        let targets = this.getTargetsFromButton(element);
        targets.forEach(target => {
            target.classList.add('collapse-element');
            if (element.dataset.collapseMethod === 'height') {
                target.classList.add('collapse-height');
            }
        });
        if (!element.dataset.collapseState) element.dataset.collapseState = "true";
        let initializeCollapse = this.verifyMinHeight(element);
        this.repaint(element);
        if (!initializeCollapse) return;
        element.addEventListener('click', (event) => {
            this.toggle(element);
        });
    }

    collapse(element, toggleState = true) {
        let targets = this.getTargetsFromButton(element);
        let maxHeight = (element.dataset.collapsedHeight || 0) + 'px';
        let animationDuration = (element.dataset.collapseAnimationDuration || 250);
        if (toggleState) element.dataset.collapseState = "true";
        targets.forEach(target => {
            target.dataset.collapseState = "true";
            target.dataset.collapseHeight = target.clientHeight;
            if (element.dataset.collapseMethod === "height") {
                if (target.style.maxHeight != ((element.dataset.collapsedHeight || 0 ) + 'px')) {
                    if (window.Element.prototype.animate === undefined) {
                        target.style.maxHeight = (element.dataset.collapsedHeight || 0 ) + 'px';
                        this.triggerEvent(element, targets, 'collapsed');
                    } else {
                        let animation = target.animate([
                            { maxHeight: target.clientHeight + 'px' },
                            { maxHeight: maxHeight },
                        ], {
                            duration: parseInt(animationDuration),
                            easing: 'ease'
                        });
                        target.style.maxHeight = (element.dataset.collapsedHeight || 0 ) + 'px';
                        animation.onfinish = () => {
                            this.triggerEvent(element, targets, 'collapsed');
                        }
                    }
                }
            } else if (element.dataset.collapseMethod === "toggle") {
                target.style.display = "none";
                this.triggerEvent(element, targets, 'collapsed');
            }
        });
        if (element.dataset.collapseMethod === "height") {
            this.triggerEvent(element, targets, 'collapsed-before-end');
        }
    }

    uncollapse(element, toggleState = true) {
        let targets = this.getTargetsFromButton(element);
        let maxHeight = (element.dataset.collapsedHeight || 0) + 'px';
        let animationDuration = (element.dataset.collapseAnimationDuration || 250);
        if (toggleState) element.dataset.collapseState = "false";
        targets.forEach(target => {
            target.dataset.collapseState = "false";
            if (element.dataset.collapseMethod === "height") {
                let currentMaxHeight = target.style.maxHeight;
                target.style.maxHeight = "";
                if (currentMaxHeight != "") {
                    let height = target.clientHeight == 0 ? target.dataset.collapseHeight : target.clientHeight;
                    if (window.Element.prototype.animate === undefined) {
                        target.style.maxHeight = height + 'px';
                        this.triggerEvent(element, targets, 'uncollapsed');
                    } else {
                        let animation = target.animate([
                            { maxHeight: maxHeight },
                            { maxHeight: height + 'px' },
                        ], {
                            duration: parseInt(animationDuration),
                            easing: 'ease'
                        });
                        this.triggerEvent(element, targets, 'uncollapsed-before-end');
                        animation.onfinish = () => {
                            this.triggerEvent(element, targets, 'uncollapsed');
                        }
                    }
                }
            } else if (element.dataset.collapseMethod === "toggle") {
                target.style.display = "";
                this.triggerEvent(element, targets, 'uncollapsed');
            }
        });
        if (element.dataset.collapseMethod === "height") {
            this.triggerEvent(element, targets, 'uncollapsed-before-end');
        }
    }

    toggle(element) {
        let isCollapsed = this.isCollapsed(element);
        this[isCollapsed ? "uncollapse" : "collapse"](element);
    }


    repaint(element) {
        let isCollapsed = this.isCollapsed(element);
        this[isCollapsed ? "collapse" : "uncollapse"](element);
    }

    isCollapsed(element) {
        return element.dataset.collapseState === "true";
    }

    getTargetsFromButton(element) {
        let targets = document.querySelectorAll(element.dataset.target);
        if (!targets) throw new Error(`Cannot find collapse targets (${element.dataset.targets})`)
        return targets;
    }

    triggerEvent(collapseButton, targets, eventName) {
        if (!targets) {
            targets = this.getTargetsFromButton(collapseButton);
        }
        [collapseButton, ...targets].forEach(loopElement => {
            loopElement.dispatchEvent(new CustomEvent('collapse-'+eventName));
        });
    }

    verifyMinHeight(element) {
        const collapsedMaxHeight = element.dataset.collapsedHeight;
        let target = this.getTargetsFromButton(element)[0];
        const verticalPadding = parseInt(window.getComputedStyle(target).paddingTop) + parseInt(window.getComputedStyle(target).paddingBottom);
        const isShorterThanCollapsedHeight = (target.clientHeight - verticalPadding) < collapsedMaxHeight;
        if (collapsedMaxHeight && isShorterThanCollapsedHeight) {
            element.dataset.collapseState = "false";
            element.classList.remove('cursor-pointer')
            element.querySelectorAll('.hidden-collapsed').forEach(target => {
                target.style.display = "none";
            });
            return false;
        }
        return true;
    }
}
